export default __webpack_public_path__ + "static/1.2_IT-b210d3d982fdb673df2efdcfac6c3813.webp";